import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import { CellComponentProps } from "../../types";

type RolePermissionsListItemActionCellProps = CellComponentProps;

const RolePermissionsListItemActionCell = ({
  permission,
}: RolePermissionsListItemActionCellProps) => {
  return (
    <Box align="center" gap="small" fullWidth>
      <TextEllipsis tooltip={permission.name} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="p" variant="p-body3">
            {permission.name}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default RolePermissionsListItemActionCell;
